import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useZoneGetStaticItems = (enabled: boolean = true) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-static-items'],
        enabled,
        queryFn: async () => {
            const response = await zoneApiClient.getCaseFileStaticItems();

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve static items.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
    });
};
